import React, {Component} from 'react';
import StandardCRUD from "../../../components/StandardCRUD" //component that used for standard crud from

import data_field from './_field'; // fields form
import SidebarDataMaster from '../SidebarDataMaster';
import SectionDataView from '../../../containers/_layout/SectionDataView';
import ModalKategori from '../../../components/ModalKategori';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import { Spinner } from "react-bootstrap";
import broker from '../../../utils/broker';
import config from '../../../utils/config';
import dataStore from '../../../stores/data';
import moment from 'moment-with-locales-es6';
import Highcharts from "highcharts";
import { Modal } from "react-bootstrap"
import TableTraffic from './TableTraffic';

class Pelanggan extends Component {
  constructor(props) {
    super(props);

    this.options = {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 6,
      hidePageListOnlyOnePage: true,
      clearSearch: true,
      alwaysShowAllBtns: false,
      withFirstAndLast: false
    }
    this.state = {
      reload:false,
      loading: false,
      date: [new Date(), new Date()],
      date_table : new Date(),
      data_chart : {},
      modal_chart : false,
      modal_table_tr : false,
      pelanggan_id : '',
      id_pk_column: 'id',
      url: { url_get_data : '/pelanggan', url_save_data: '/pelanggan', url_update_data: '/pelanggan', 
             url_delete_data: '/pelanggan', url_get_data_per: '/pelanggan' },
      title: 'Master Pelanggan', 
      title_add : 'Add Data Master Pelanggan', 
      fields: data_field.data, 
      columns: [
            { header: 'Kategori', id: 'kategori', accessor: 'kategori', child_accessor: null,
                Cell: row => {
                    return (row.value.substring(0, 25) + (row.value.length > 25 ? '.....' : ''))
                }
            },
            { header: 'Klasifikasi', id: 'klasifikasi', accessor: 'klasifikasi', child_accessor: null,
                Cell: row => {
                    return (row.value) ? (row.value.substring(0, 25) + (row.value.length > 25 ? '.....' : '')) : ''
                }
            },
            { header: 'Nama', id: 'nama_pelanggan', accessor: 'nama_pelanggan', child_accessor: null,
                Cell: row => {
                    return (row.value.substring(0, 25) + (row.value.length > 25 ? '.....' : ''))
                }
            },
            { header: 'Max Upload', id: 'max_download', accessor: 'max_download', child_accessor: null,
                Cell: row => {
                    return `${row.value} Mbps`;
                    }
            },
            { header: 'Max Upload', id: 'max_upload', accessor: 'max_upload', child_accessor: null,
                Cell: row => {
                    return `${row.value} Mbps`;
                    }
            },
            { header: 'Status', id: 'status', accessor: 'status', child_accessor: null,
                Cell: row => {
                    return <span className={(row.value === 'AKTIF') ? 'badge badge-light' : 'badge badge-dark'}>{row.value}</span>
                    }
            },
            { header: 'Bandwidth', id: 'id', accessor: 'id', child_accessor: null,
                Cell: row => {
                    return <a href="!#" data-toggle="modal" className="btn btn-xs pd-x-10 btn-outline-dark btn-uppercase mg-l-5"
                                onClick={() => this.showBandwidth(row.row.id)}>
                                <i className="fa fa-table"></i>
                            </a>;
                }
            },
            { header: 'Graphic', id: 'id', accessor: 'id', child_accessor: null,
                Cell: row => {
                    return <a href="!#" data-toggle="modal" className="btn btn-xs pd-x-10 btn-outline-dark btn-uppercase mg-l-5"
                                onClick={() => this.showModal(row.row.id)}>
                                <i className="fa fa-chart-bar"></i>
                            </a>;
                }
            },
        ],
        
    }
    this.changeDateTable = this.changeDateTable.bind(this);
    this.onChange = this.onChange.bind(this);

  }

  showModal(id) {
    this.setState({pelanggan_id : id, modal_chart : true, data_chart : {}})
  }

  showBandwidth(id) {
    this.setState({pelanggan_id : id, modal_table_tr : true})
  }

  showGraphic(){
    broker.fetchSupport.get(`generate_graphic_bydate?id=${this.state.pelanggan_id}&date_start=${moment(this.state.date[0]).locale('id').format('YYYY-MM-DD')}&date_end=${moment(this.state.date[1]).locale('id').format('YYYY-MM-DD')}`)
        .then(res => {
            const { data } = res;
            if (data) {
                this.setState({data_chart : data}, function(){
                  this.renderChart();
                });
            } else {

            }
        }).catch(err => {
            
        });
  }

  renderChart(){
    var option = {
          chart: {
              type: 'column',
          },
          legend: {
              enabled: false
          },
          title: {
              text: 'Data ' + this.state.data_chart.nama_pelanggan,
              x: -20
          },
          subtitle: {
              text: '<span style="color:#00CC33;">Download</span>' + '<br>' +
                  '<span style="color:#0000FF;">Upload</span>',
              x: -20
          },
          xAxis: {
              categories: this.state.data_chart.category
          },
          yAxis: {
              max: this.state.data_chart.pelanggan.max_download,
              min : this.state.data_chart.rate.upload_min,
              title: {
                  text: 'Bandwidth'
              },
              plotLines: [{
                  value: 0,
                  width: 1,
                  color: '#808080'
              }]
          },
          tooltip: {
              formatter: function () {
                  var tooltip;
                  if (this.series.name == 'Download') {
                      tooltip = '<span style="color:' + this.series.color + '">' + this.series
                          .name + '</span>: <b>' + this.point
                          .stackTotal + ' Mbps</b><br/>';
                  } else {
                      tooltip = '<span style="color:' + this.series.color + '">' + this.series
                          .name + '</span>: <b>' + this.y +
                          ' Mbps</b><br/>';
                  }
                  return tooltip;
              }
          },
          plotOptions: {
              column: {
                  stacking: 'normal',
                  pointPadding: 0,
                  borderWidth: 0
              },
              series: {
                  pointPadding: 0,
                  groupPadding: 0,
                  animation: false
              }
          },
          credits: {
              enabled: false
          },
          exporting: {
              width: 900
          },
          series: this.state.data_chart.series,
  
      };

      this.chart = new Highcharts.chart(this.refs.chart, option);
      this.chart.reflow();

  }

  changeDateTable(event){
    this.setState({date_table : event.target.value})
  }

  onChange(date) {
    if (moment(date[0]).month() !== moment(date[1]).month()) {
        alert("Periode Bulan Harus Sama")
    }
    this.setState({date : date});
}

  render() {
    return (
      <React.Fragment>
          <SidebarDataMaster location={this.props.location.pathname}/>
          <StandardCRUD 
                columns={this.state.columns} 
                url={this.state.url} 
                title={this.state.title} 
                title_add={this.state.title_add} 
                fields={this.state.fields} 
                id_pk={null} 
                add_form={true}
                id_pk_column={this.state.id_pk_column}
                style_container="content content-components"
                search_query=""
                search_column={true}
          />
          <SectionDataView />
          <ModalKategori />
          <Modal size="lg" show={this.state.modal_chart} onHide={() => this.setState({modal_chart : false})} animation={false} backdrop="static" keyboard={false} centered>
            <Modal.Header closeButton>
                <Modal.Title>Graphic Per Pekerjaan</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row mb-2">
                <div className="col-sm-12">
                    <DateRangePicker onChange={this.onChange} value={this.state.date} className="mg-r-10"/>
                    <button onClick={()=> this.showGraphic()} className="btn btn-sm btn-white mg-r-10" >
                            Show Graphic
                    </button>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div ref="chart"></div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-primary" type="button" onClick={() => this.setState({modal_chart : false})}>Close</button>
            </Modal.Footer>
          </Modal>  
          <Modal size="xl" show={this.state.modal_table_tr} onHide={() => this.setState({modal_table_tr : false})} animation={false} backdrop="static" keyboard={false} centered>
            <Modal.Header closeButton>
                <Modal.Title>Table Per Pekerjaan</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row mb-0">
                <div className="col-sm-12 form-inline">
                    <input type="date" value={this.state.date_table} onChange={this.changeDateTable}  className="form form-control form-sm col-sm-3 mx-sm-3" />
                    <h4>Tanggal : {moment(this.state.date_table).locale('id').format('DD-MM-YYYY')}</h4>
                </div>
              </div>
              <div className="row">
              <TableTraffic pelanggan_id={this.state.pelanggan_id} date_table={moment(this.state.date_table).locale('id').format('YYYY-MM-DD')}/>
              </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-primary" type="button" onClick={() => this.setState({modal_table_tr : false})}>Close</button>
            </Modal.Footer>
          </Modal>
      </React.Fragment>
    );
  }
}

export default Pelanggan;
